import { Locale } from 'modules/i18n';

export const translation = {
  [Locale.en]: {
    done: 'Done!',
    doneDescription:
      'You will be able to claim your funds in {period} {period, plural, =1 {day} other {days}}',
    buttonText: 'OK',
  },
};
